import { FC, memo, useEffect, useState } from "react";
import CoverageAvailableTableRow from "src/components/actionDashboard/coverageTableRow";
import PaginationNav from "src/components/actionDashboard/paginationNav";
import { CoverageAvailableTypeProps, TreatableProps } from "./types";
import CoverageTableHeader from "src/components/actionDashboard/coverageTableHeader";
import NoDataFound from "src/components/noDataFoundComponent";
import { QueryParamsState } from "src/components/manufacturer/caseListing";


const CoverageAvailable: FC<CoverageAvailableTypeProps> = ({ tableData, currentPage, onPageChange, refreshListing ,changeAction}): JSX.Element => {

   const [queryParam, setQueryParam] = useState<QueryParamsState>({
       direction: "desc",
       sort_by: "bi_case_id",
     });
   
     const [sortedData, setSortedData] = useState<TreatableProps[]>([]);
   
     // Initialize sortedData whenever new data comes from props
     useEffect(() => {
       if (tableData?.treatables_data) {
         setSortedData([...tableData.treatables_data]);
       }
     }, [tableData]);
   
     const changeIdOrder = (tableHeader: string) => {
       const newParams: QueryParamsState = {
         sort_by: tableHeader,
         direction:
           tableHeader === queryParam.sort_by
             ? queryParam.direction === "desc"
               ? "asc"
               : "desc"
             : "desc",
       };
   
       let sorted = [...(tableData?.treatables_data || [])];
   
       switch (newParams.sort_by) {
         case "bi_case_id":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? Number(a.bi_case_id) - Number(b.bi_case_id)
               : Number(b.bi_case_id) - Number(a.bi_case_id)
           );
           break;
   
         case "patient_id":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? Number(a.patient_id) - Number(b.patient_id)
               : Number(b.patient_id) - Number(a.patient_id)
           );
           break;
   
         case "drug_name":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.drug_name || "").localeCompare(b.drug_name || "")
               : (b.drug_name || "").localeCompare(a.drug_name || "")
           );
           break;
   
         case "patient_initials_dob":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.patient_initials_dob || "").localeCompare(b.patient_initials_dob || "")
               : (b.patient_initials_dob || "").localeCompare(a.patient_initials_dob || "")
           );
           break;
   
         case "bi_completed":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.bi_completed || "").localeCompare(b.bi_completed || "")
               : (b.bi_completed || "").localeCompare(a.bi_completed || "")
           );
           break;
   
         case "physician":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.physician || "").localeCompare(b.physician || "")
               : (b.physician || "").localeCompare(a.physician || "")
           );
           break;
   
         case "insurance_type":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.insurance_type || "").localeCompare(b.insurance_type || "")
               : (b.insurance_type || "").localeCompare(a.insurance_type || "")
           );
           break;

         case "payer":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.payer || "").localeCompare(b.payer || "")
               : (b.payer || "").localeCompare(a.payer || "")
           );
           break;

         case "review_type":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.review_type || "").localeCompare(b.review_type || "")
               : (b.review_type || "").localeCompare(a.review_type || "")
           );
           break;

         case "product_name":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.product_name || "").localeCompare(b.product_name || "")
               : (b.product_name || "").localeCompare(a.product_name || "")
           );
           break;

         case "medical_coverage_status":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.medical_coverage_status || "").localeCompare(b.medical_coverage_status || "")
               : (b.medical_coverage_status || "").localeCompare(a.medical_coverage_status || "")
           );
           break;
   
         case "pharmacy_coverage_status":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.pharmacy_coverage_status || "").localeCompare(b.pharmacy_coverage_status || "")
               : (b.pharmacy_coverage_status || "").localeCompare(a.pharmacy_coverage_status || "")
           );
           break;

         case "released":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.released || "").localeCompare(b.released || "")
               : (b.released || "").localeCompare(a.released || "")
           );
           break;
            case "received_at":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.received_at || "").localeCompare(b.received_at || "")
               : (b.received_at || "").localeCompare(a.received_at || "")
           );
           break;
            case "pa_required":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.pa_required || "").localeCompare(b.pa_required || "")
               : (b.pa_required || "").localeCompare(a.pa_required || "")
           );
           break;
   
         case "qty":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? Number(a.qty ?? 0) - Number(b.qty ?? 0)
               : Number(b.qty ?? 0) - Number(a.qty ?? 0)
           );
           break;

         case "refills":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? Number(a.refills ?? 0) - Number(b.refills ?? 0)
               : Number(b.refills ?? 0) - Number(a.refills ?? 0)
           );
           break;
   
         default:
           break;
       }
       setSortedData(sorted);
       setQueryParam(newParams);
     };

  return (
    <>
      <div className="table-responsive table-responsive-sm table-responsive-md table-responsive-lg flex-fill">
        <table className="table table-striped table-sm m-0" style={{minHeight:'300px'}}>
          <CoverageTableHeader queryParam={queryParam}
            changeIdOrder={changeIdOrder} />
          <tbody className="position-relative">
            {sortedData && sortedData.length > 0 ?
              sortedData.map((data: TreatableProps, index: number) => (
                <CoverageAvailableTableRow refreshListing={refreshListing} treatable={data} key={index} />
              ))
              : <NoDataFound />
            }
          </tbody>
        </table>
      </div>
      {tableData && tableData.page_count && tableData.page_count > 1 ?
        <PaginationNav currentPage={currentPage} pageCount={tableData.page_count} onPageChange={onPageChange}  />
        : null
      }
    </>
  );
};

export default memo(CoverageAvailable);
